import React, {useEffect, useState} from "react";
import PropTypes, {InferProps} from "prop-types";
import {ProjectListView} from "./project-list.view";
import {StringParam, useQueryParam} from "use-query-params";
import {Project} from "@betrue/shared/interfaces";
import {useProject, useSessionProject} from "@betrue/front/services";

export const ProjectListPropsTypes = {
  deleteLabel: PropTypes.string,

}
export type ProjectListProps = InferProps<typeof ProjectListPropsTypes>

export const ProjectList = (props: ProjectListProps) => {
  const [p,l, {projects,}] = useProject()
  const [, setCurrentProject] = useState<Project>()

  const [, setProjectId] = useQueryParam('projectId', StringParam);
  const [, setSessionProject] = useSessionProject()


  useEffect(() => {
    if (p) {
      setSessionProject(p)
    }
  }, [p])

  useEffect(() => {
    projects()
  },[])

  useEffect(()=> {
    if(p){
      setCurrentProject(p)
    }
  },[p])


  const handleProjectSelection = (id) => {
    setProjectId(id)
    window.location.reload()
  }

  if (!Array.isArray(l)) return (<>...</>)

  return (
    <ProjectListView {...props} projectList={l} selectedProject={p} onProjectSelected={handleProjectSelection}/>
  );
}


ProjectList.propTypes = ProjectListPropsTypes
